var _circle, _path, _path2, _path3, _g, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuLiving(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.1667,
    cy: 20.8333,
    r: 5,
    stroke: "#5C5B5A",
    strokeWidth: 1.66667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 15.8333C10.4059 16.453 11.7411 17.7205 12.3695 18.2308C12.4509 18.2969 12.5 18.3951 12.5 18.5V25.3709C12.5 25.5984 12.2799 25.7508 12.0754 25.6512C11.4239 25.3341 10.3145 24.664 9.58333 23.75C7.91667 21.6667 8.33333 21.25 7.5 20C6.91376 19.1206 5.85498 17.6399 5.23027 17.2009C5.10512 17.113 5 16.976 5 16.8231V15.3333C5 15.1492 5.14869 14.9999 5.33263 15.0072C6.28646 15.0452 7.98734 15.2437 9.16667 15.8333Z",
    fill: "#5C5B5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.1666H29.1667L30.5325 30.5565C30.6945 32.4999 29.1608 34.1666 27.2107 34.1666H14.456C12.5059 34.1666 10.9723 32.4999 11.1342 30.5565L12.5 14.1666Z",
    fill: "#D1CFCD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1451_18244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 14,
    width: 20,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.1666H29.1667L30.5325 30.5565C30.6945 32.4999 29.1608 34.1666 27.2107 34.1666H14.456C12.5059 34.1666 10.9723 32.4999 11.1342 30.5565L12.5 14.1666Z",
    fill: "#D1CFCD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1451_18244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 34.1666L5 1.66663V34.1666H36.6667Z",
    fill: "#C6C6C6"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1911 9.16671C23.2832 8.90606 23.3333 8.62557 23.3333 8.33337C23.3333 6.95266 22.214 5.83337 20.8333 5.83337C19.4526 5.83337 18.3333 6.95266 18.3333 8.33337C18.3333 8.62557 18.3835 8.90606 18.4756 9.16671H17.5C14.7386 9.16671 12.5 11.4053 12.5 14.1667H29.1667C29.1667 11.4053 26.9281 9.16671 24.1667 9.16671H23.1911Z",
    fill: "#FF791C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuLiving);
export default __webpack_public_path__ + "static/media/wikiMenuLiving.5f078470574aaaa9f39cac7f4d9a32e6.svg";
export { ForwardRef as ReactComponent };